import { DealPartner, DealPartnerForm, DmpAudienceProvider, PlatformFeeEnum } from '@/app/shared/_models/models';
import { SharedStoreService } from '@/app/shared/_services/shared-store.service';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormGroup, ValidationErrors } from '@angular/forms';
import { map, take } from 'rxjs/operators';
export type PartnerInfoMode = 'create' | 'edit' | 'disabled';

@Component({
  selector: 'app-deal-partner-info',
  templateUrl: './deal-partner-info.component.html',
  styleUrls: ['./deal-partner-info.component.less']
})
export class DealPartnerInfoComponent implements OnInit {
  @Input() mode: PartnerInfoMode = 'create';
  @Input() partner: DealPartner;
  @Input() dmpAudienceProviders: DmpAudienceProvider[] = [];
  @Input() form: FormGroup<DealPartnerForm>;
  @Output() statusChange = new EventEmitter<boolean>();
  @Output() delete = new EventEmitter<void>();

  platformFeeOptions: { value: PlatformFeeEnum; displayName: string }[] = [];

  availableAudienceProviders: DmpAudienceProvider[] = [];
  private readonly demandMarginPercentageValidators = [
    (control: AbstractControl): ValidationErrors | null => {
      const value = control?.value;
      if (value && (value < 0 || value > 80)) {
        return { marginRange: 'Client Margin must be between 0-80%' };
      }
      return null;
    }
  ];


  constructor(
    private sharedStoreService: SharedStoreService
  ) {}

  ngOnInit() {
    this.initializePlatformFeeType();
    this.initializeAudienceProviders();
    this.initDisabledMode();
    this.form.get('defaultDemandMargin').setValidators(this.demandMarginPercentageValidators);
    this.form.get('defaultDemandMargin').updateValueAndValidity();
  }


  private initDisabledMode(): void {
    if (this.mode === 'disabled') {
      this.form.disable();
    }
  }

  private initializeAudienceProviders() {
    const uniqueProviderIds = new Set<number>();

    this.availableAudienceProviders = [...this.dmpAudienceProviders];
    this.dmpAudienceProviders.forEach(provider => {
      uniqueProviderIds.add(provider.providerId);
    });

    if (this.mode !== 'create' && this.partner?.audienceProviders) {
      this.partner.audienceProviders.forEach(provider => {
        if (!uniqueProviderIds.has(provider.providerId)) {
          this.availableAudienceProviders.push(provider);
          uniqueProviderIds.add(provider.providerId);
        }
      });
    }
  }

  private initializePlatformFeeType(): void {
    this.sharedStoreService.getSharedEnum('PartnerPlatformFeeType').pipe(
      take(1),
      map((response) =>
        (Object.keys(response))
          .map(value => ({ value: value as PlatformFeeEnum, displayName: response[value] }))
          .sort((a, b) => a.displayName.localeCompare(b.displayName))
      )
    ).subscribe(platformFeeTypes => {
      this.platformFeeOptions = platformFeeTypes;
    });
  }
}
